














/* Created- 04 - Apr - 2019 */
import { Component, Vue, Prop } from "vue-property-decorator";
import { eParticaAction, ParticaEvent } from "../../../Models/ParticaEvent";
@Component(
	{
		name: "ArticleFacebook"
	})
export default class ArticleFacebook extends Vue {
	@Prop() private facebook: string;
	private changed(event: any) {
		this.$emit("update:facebook", event);
		this.$emit("partica-event", { action: eParticaAction.PROPERTY_CHANGED } as ParticaEvent);
	}
}
